export enum State {
  Announced = "announced",
  Delivered = "delivered",
}

export enum Condition {
  Fine = "fine",
  SlightlyDamaged = "slightlyDamaged",
  HeavilyDamaged = "heavilyDamaged",
  Rejected = "rejected",
}
